module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }